import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => { if (user && user.role === "admin") nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); toast.success("Welcome back!"); nav("/admin"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); setLoading(false); }
  };

  return (
    <main className="min-h-screen bg-navy-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-6 text-sm"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="h-14 w-14 rounded-2xl bg-navy-900 text-gold flex items-center justify-center mb-5"><Lock className="h-7 w-7" /></div>
          <h1 className="font-display text-2xl font-bold text-navy-900">Admin Sign In</h1>
          <p className="text-sm text-slate-500 mt-1 mb-6">Manage resources and view submissions.</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email</Label><Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="login-email" /></div>
            <div><Label>Password</Label><Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="login-password" /></div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 rounded-full bg-navy-900 hover:bg-navy-700 text-white font-bold">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
}
